import React from 'react';
import { Link } from 'react-router-dom';

export default function KoreanWear() {
  return (
    <div className="soon">
      <p className="eyebrow">Korean Wear</p>
      <h1 className="soon__title">Coming Soon</h1>
      <p className="soon__text">This collection is on its way. In the meantime, explore our clothing and handbags.</p>
      <div className="row row--center">
        <Link to="/shop/clothing" className="btn">Shop clothing</Link>
        <Link to="/shop/handbags" className="btn btn--outline">Shop handbags</Link>
      </div>
    </div>
  );
}
